module.exports = "<div class=\"row\">\r\n  <div class=\"col-lg-4 col-md-3 col-sm-2 col-xs-1\"></div>\r\n  <div class=\"col-lg-4 col-md-6 col-sm-8 col-xs-10\">\r\n    <div class=\"error-container\">\r\n      <h1>{{error.title}}</h1>\r\n      <div>\r\n        <div [innerHTML]=\"error.message\"></div>\r\n        <div [hidden]=\"!error.forwardText\">\r\n          <a href=\"#\" (click)='onForward()'>{{error.forwardText}}</a>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/error/error.component.html
// module id = ./src/app/error/error.component.html
// module chunks = main